import React from "react";

export default function DisplayFieldValue({ input, defaultValue = null, prefix = null, suffix = null }) {
  if (!input.value) return defaultValue ? <>{defaultValue}</> : null;
  return (
    <>{prefix}{input.value}{suffix}</>
  )
}